import { createFileRoute } from "@tanstack/react-router";
import { Home } from "./index";

export const Route = createFileRoute("/preview-light")({
  head: () => ({
    meta: [
      { title: "Light Theme Preview — MLC Epoxy Floors" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: PreviewLight,
});

function PreviewLight() {
  return (
    <div className="section-light">
      <div className="sticky top-16 z-30 border-y border-border bg-copper/95 text-white text-xs font-bold uppercase tracking-widest text-center py-2">
        Light theme preview — not the live site · visit /  to see the real (dark) site
      </div>
      <Home />
    </div>
  );
}
